import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  return (
    <AnimatePresence>
      {isOffline && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="sticky top-16 z-40 overflow-hidden border-b border-warning bg-warning/10"
        >
          <div className="container flex items-center gap-2 px-4 py-2 text-sm text-foreground">
            <WifiOff className="h-4 w-4 shrink-0 text-warning" />
            <span>Sem conexão. Suas alterações serão salvas quando voltar online.</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
